module.exports = __webpack_public_path__ + "img/logo.35eb6713.png";